import aboutBanner from '../img/vonecia-carswell-crop-unsplash_450.jpg'
import questions from '../img/graphics/questions.svg'
// import ReactAudioPlayer from "react-audio-player";

export default function About() {
  return (
    <>
    <div className="hero-about">
    <div id="hero" >
      <img className="hero-img" src={aboutBanner} alt="colorful people" title="Photo credit: Vonecia Carswell via Unsplash"/>
    </div> 
    </div> 

<div className="container about p-flow">
    <h1>About Aphasia</h1>
    
    <div style={{ width: '100%', aspectRatio: '16/9', marginBottom: '2rem' }}>
      <iframe
        width="100%"
        height="100%"
        src="https://www.youtube.com/embed/GThkxrKbQTI"
        title="NAS Aphasia & Mental Health"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
        className="youtube-frame"
      ></iframe>
    </div>

<ul>
  <li>For more information about aphasia and mental health resources and FAQ’s for people for aphasia, check out the following <a href="https://bit.ly/3Il6ZlY"><span className="color-blue"><u>LIST</u></span></a>.</li>
  <li>If you have questions or comments, please take our NAS Aphasia & Mental Health Video Survey <a href="https://docs.google.com/forms/d/14_k9u9hvjFJ8n3YDzQ2ZcZ6HBI9rCCfOWsPvfKrg5Mc/edit"><span className="color-blue"><u>HERE</u></span></a>. </li>
</ul>

<h2 className='waffle-title'>What is Aphasia?</h2>

  <p>Aphasia is a language disorder due to a stroke, brain injury, brain tumor or surgery, brain infection or neurological disease. A person with aphasia (PWA) may have difficulty speaking, reading, writing, and understanding, but judgment and intelligence are intact - an invisible disability. No two people with aphasia are ever exactly alike and there is a range of various forms of aphasia. Definitions and the common types of aphasia link: 
    <a href="https://www.aphasia.org/aphasia-definitions/"> Aphasia.org</a></p>

<h2 className="waffle-title">How common is aphasia?</h2>
<p>It is more common than you may think:</p>
<div className='about-'>
<ul>
  <li>It affects well over <span className="color-blue"> 2 million</span>  people in the U.S.</li>
  <li>The number of people in the U.S with aphasia, is more than the combined population of Wyoming, Vermont & Alaska</li>
  <li>Aphasia affects approximately 1 in every 3 stroke survivors.</li>
  <li>There are about <span className="color-blue">150 times</span> more people with aphasia than there are people with ALS.</li>
</ul></div>
<h2 className="waffle-title">It is common that people with aphasia:</h2>
<div className='about-'>
<ul>
  <li>May pause a lot. The word may be on the tip of their tongue, but they are unable to access it in that moment.</li>
  <li>May say yes and no when they mean the opposite. This can make it difficult, as answers may be unreliable.</li>
  <li>May have difficulties with numbers, times, and dates and need more time to comprehend.</li>
  <li>May have difficulty with excessive noises or background noises.</li>
  <li>May have difficulty with choices, such as choices of salad dressings offered by a restaurant waiter.</li>
</ul></div>
<h2 className="waffle-title">How can you help with communication?</h2>
    <div className="even-columns -flex">
    <div className="about-">
    <img src={questions} id="questions" alt="people asking questions" className="about-img"/>
    <ul>
      <li>Be <span className="color-blue">patient</span> and wait for a response.</li>
      <li>Reduce background noise (TV, radio, other people).</li>
      <li><span className="color-blue">Speak simply</span> and directly to me.</li>
      <li>Say one thing at a time.</li>
      <li>Ask <span className="color-blue">yes/no</span> questions.</li>
      <li>Write down key words (names, places, numbers).</li>
      <li><span className="color-blue">Gesture</span>, draw diagrams or pictures.</li>
      <li>Relax and be natural.</li>
      <li>Don't pretend you understand.</li>
      <li><span className="color-blue">Recap</span> and check that you both understand.</li>
    </ul>
             </div>
         </div>
    </div>
</>
  )
}